// extracted by mini-css-extract-plugin
export default {"main":"GridItem_main__5OYUe","gridIcon":"GridItem_gridIcon__mh4+b","gridTitle":"GridItem_gridTitle__JfVrN","gridInfo":"GridItem_gridInfo__u6XW7","yourImc":"GridItem_yourImc__PqLGU"};